import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

export interface IPullToRefresh {
  isPulledMarketPlace: boolean;
  isPulledTakesFeed: boolean;
  isPulledTakesProfile: boolean;
} 

let initialState: IPullToRefresh = {
  isPulledMarketPlace: false,
  isPulledTakesFeed: false,
  isPulledTakesProfile: false,
};

export const PullToRefreshSlice = createSlice({
  name: "pull_Refresh_slice",
  initialState,
  reducers: {
    setPulledMarketPlace: (state, action: PayloadAction<boolean>) => {
      state.isPulledMarketPlace = action.payload;
      return state;
    },
    setPulledTakesFeed: (state, action: PayloadAction<boolean>) => {
      state.isPulledTakesFeed = action.payload;
      return state;
    },
    setPulledTakesProfile: (state, action: PayloadAction<boolean>) => {
      state.isPulledTakesProfile = action.payload;
      return state;
    },
  },
});

export const { setPulledMarketPlace  , setPulledTakesFeed} = PullToRefreshSlice.actions;

export default PullToRefreshSlice.reducer;
